export default {
  init() {
    // JavaScript to be fired on all pages
    
    // initiate home slider
      $('.slider').slick({
        infinite: true,
        autoplay: true,
        pauseOnHover: false,
        arrows: false,
        cssEase: 'ease-out',
        speed: 3500,
        dots: true,
        appendDots: $( '.dots_holder' ),
      });


      $( '.big_team_element' ).on( 'click', function(){


        var open_element = $( this ).data( 'item' );
        $( '#'+open_element ).toggleClass( 'active' );

      });

      $( '.sluit_big_element' ).on( 'click', function(e){

        e.preventDefault();

        $( this ).parent().parent().parent().removeClass( 'active' );

      }); 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  
     // header change on scroll
     $(window).scroll(function(){
      var sticky = $('#header'),
          scroll = $(window).scrollTop();
    
      if (scroll >= 100){
        sticky.addClass('fixed');
      }else{
        sticky.removeClass('fixed');
      }
    });

    // hamburger menu
    // menu toggle mobile 
    $('.icon_burger').on( 'click', function() {
      $('.top-menu').toggleClass('top-animate');
      $('.mid-menu').toggleClass('mid-animate');
      $('.bottom-menu').toggleClass('bottom-animate');

      $('.nav-primary').toggleClass('active-menu');
      
      $('body').toggleClass('noscroll');
    });

    $('.menu-item-has-children .svg-inline--fa').on( 'click', function() {
      
      $( this ).parent().find( '.sub-menu' ).toggleClass( 'active-sub-menu' );

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js